<script>
    import { scale, fade } from 'svelte/transition';
</script>

<div class="Confirm" transition:fade={{ duration: 100 }}>
    <div class="spinner-holder">
        <div class="spinner " transition:scale={{ start: .2, duration: 150 }}>
            <i class="far fa-check"></i>
        </div>
    </div>
</div>

<style>
    .Confirm {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 25;
        background-color: #fff;
    }
    .spinner-holder {
        position: absolute;
        width: 100%;
        top: 50%;
        transform: translateY(-50%);
        text-align: center;
    }
    .spinner {
        display: inline-block;
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        color: #fff;
        background-color: #2ecc71;
        font-size: 28px;
        border-radius: 50%;
        position: relative;
        -webkit-animation-duration: .3s;
        animation-duration: .3s;
    }
</style>